const DATE_FORMATTER = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
})

const TIME_FORMATTER = new Intl.DateTimeFormat('en-US', {
  hour: 'numeric',
  minute: '2-digit',
  hour12: true,
})

/** Formats ISO UTC timestamp for display in the SP local timezone (BR-SPW-HIS-04). */
export function formatCompletionDate(isoUtc: string): string {
  const date = new Date(isoUtc)
  if (Number.isNaN(date.getTime())) return ''
  const datePart = DATE_FORMATTER.format(date)
  const timePart = TIME_FORMATTER.format(date)
  return `${datePart} — ${timePart}`
}
